import {HttpService} from "./api/HttpService";

class CommunicationsService {

    deleteCommunication(communicationId) {
        return new Promise((resolve, reject) => {
            HttpService.create().delete(`/communications/${communicationId}`)
                .then(result => resolve(result.data))
                .catch(err => reject(err));
        });
    }

    dissociateEvent(communicationId) {
        return new Promise((resolve, reject) => {
            HttpService.create().delete(`/communications/${communicationId}/event`)
                .then(result => resolve(result.data))
                .catch(err => reject(err));
        });
    }

    getCommunication(communicationId) {
        return new Promise((resolve, reject) => {
            HttpService.create().get(`/communications/${communicationId}`)
                .then(result => resolve(result.data))
                .catch(err => reject(err));
        });
    }

    get communicationRecipientLocators(){
        return new Promise((resolve, reject) =>{
            HttpService.create().get('/recipientLocators')
                .then(result => resolve(result.data))
                .catch(err => reject(err));
        });
    }

    get communicationContacts() {
        return new Promise((resolve, reject) => {
            HttpService.create().get('/contacts')
                .then(result => resolve(result.data))
                .catch(err => reject(err));
        });
    }

    getCommunicationsReportData() {
        return new Promise((resolve, reject) => {
            HttpService.create().get(`/communications/reportData`)
                .then(result => resolve(result.data))
                .catch(err => reject(err));
        });
    }

    get contactsByGroupData() {
        return new Promise((resolve, reject) => {
            HttpService.create().get('/contactsByGroup')
                .then(result => resolve(result.data))
                .catch(err => reject(err));
        });
    }

    retrievePastCommunications() {
        return new Promise((resolve, reject) => {
            HttpService.create().get('/communications')
                .then(result => resolve(result.data))
                .catch(err => reject(err));
        });
    }

    saveCommunicationDraft(communicationDetails) {
        return new Promise((resolve, reject) => {
            HttpService.create().post('/communications/saveAsDraft', communicationDetails)
                .then(result => resolve(result.data))
                .catch(err => reject(err));
        });
    }

    saveEventAssociation(communicationId, eventId) {
        return new Promise((resolve, reject) => {
            HttpService.create().post(`/communications/${communicationId}/event/${eventId}`)
                .then(result => resolve(result.data))
                .catch(err => reject(err));
        });
    }

    sendCommunication(communicationId) {
        return new Promise((resolve, reject) => {
            HttpService.create().post(`/communications/send/${communicationId}`)
                .then(result => resolve(result.data))
                .catch(err => reject(err));
        });
    }

    sendNewCommunication(newCommunicationDetails) {
        return new Promise((resolve, reject) => {
            HttpService.create().post('/communications', newCommunicationDetails)
                .then(result => resolve(result.data))
                .catch(err => reject(err));
        });
    }

    getContactsForLocations(recipientLocations) {
        return new Promise((resolve, reject) => {
            const sortBy =`orderBy=LocationName asc`;

            const searchLocationIds = `$filter=LocationId in (${recipientLocations.join(',')})`;
            const readyQuery = `/recipientLocators/locationContacts?$count=true&${sortBy}&${searchLocationIds}`;
            HttpService.create().get(readyQuery)
                .then(result => resolve(result.data))
                .catch(err => reject(err));
        });
    }
}

const svc = new CommunicationsService();
export default svc;
